import { disallowedCharactersRegex } from './regex'

/**
 * Retrieves disallowed characters from the given string.
 * @param {string | undefined} string - The string to retrieve disallowed characters from.
 * @returns {string} - A string containing disallowed characters found in the input string.
 */
export function getDisallowedCharacters(string: string | undefined): string {
  if (!string) return ''

  const foundDisallowedCharacters: string[] = []

  string.replace(disallowedCharactersRegex, match => {
    foundDisallowedCharacters.push(match)
    return '' // Replace the matched character with an empty string
  })

  return foundDisallowedCharacters.join(' ')
}
